module.exports = __webpack_public_path__ + "img/bb.9f7ce6e8.svg";